// extracted by mini-css-extract-plugin
export default {"wrapper":"us-z","viewport":"vs-z","container":"ws-z","slide":"xs-z"};